import { ShieldAlert } from 'lucide-react';
import { Button } from '@/design-system/components/Button/Button';
import { buttonVariants } from '@/design-system/components/Button/buttonVariants';
import { cn } from '@/lib/utils';

/**
 * Shown to users who are signed into the portal but have not been granted
 * the DemoOps app. Rendered in place of the app — never redirects, so it
 * cannot loop through the portal's SSO auto-redirect.
 */
export function AccessDeniedScreen() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-graphite-950 p-5">
      <div className="max-w-md text-center">
        <ShieldAlert className="mx-auto mb-4 h-12 w-12 text-safety-500" aria-hidden="true" />
        <h1 className="mb-3 text-2xl font-semibold text-graphite-100">Access needed</h1>
        <p className="mb-2 leading-relaxed text-graphite-300">
          You&rsquo;re signed in, but your account doesn&rsquo;t have access to DemoOps yet.
        </p>
        <p className="mb-6 leading-relaxed text-graphite-500">
          Ask a portal administrator to grant you the <strong>DemoOps</strong> app in the NADC
          Portal admin panel, then reload this page.
        </p>
        <div className="flex justify-center gap-3">
          <a href="https://nadc1.net/" className={cn(buttonVariants({ variant: 'primary' }))}>
            Back to Portal
          </a>
          <Button variant="outline" onClick={() => window.location.reload()}>
            Try again
          </Button>
        </div>
      </div>
    </div>
  );
}
